import React, { useEffect, useState } from "react";
import { Container } from "components/Container";
import { Table, Tag, Button, Tooltip, Space } from "antd";
import {
  UnorderedListOutlined,
  ReloadOutlined,
  DownloadOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import ReporteService from "services/ReporteService";
import { saveAs } from "file-saver";

const TIPOS_CONSULTA_DOCUMENTO = [
  "CONSULTA_DOCUMENTOS_EXPORTAR_EXCEL",
  "CONSULTA_DOCUMENTOS_EXPORTAR_PDF",
];

const TIPO_LABELS = {
  CONSULTA_DOCUMENTOS_EXPORTAR_EXCEL: "Consulta Documentos - Excel",
  CONSULTA_DOCUMENTOS_EXPORTAR_PDF: "Consulta Documentos - PDF",
};

const BandejaReportesConsultaDocumentoPage = () => {
  const [reportes, setReportes] = useState([]);
  const [loadingRefrescar, setLoadingRefrescar] = useState(false);

  const cargarDatos = async () => {
    setLoadingRefrescar(true);
    try {
      const respuesta = await ReporteService.listar();
      const filtrados = (respuesta || []).filter((r) =>
        TIPOS_CONSULTA_DOCUMENTO.includes(r.tipo)
      );
      setReportes(filtrados);
    } finally {
      setLoadingRefrescar(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const onClickDescargar = async (reporteId) => {
    const respuesta = await ReporteService.obtenerUrl(reporteId);
    saveAs(respuesta.urlDocumento);
  };

  const columnas = [
    {
      title: "Tipo de Reporte",
      dataIndex: "tipo",
      key: "tipo",
      align: "center",
      render: (tipo) => TIPO_LABELS[tipo] || tipo,
    },
    {
      title: "Solicitante",
      dataIndex: "solicitanteNombre",
      key: "solicitante",
      align: "center",
    },
    {
      title: "Fecha Solicitud",
      dataIndex: "fechaCreacion",
      key: "fechaCreacion",
      align: "center",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      align: "center",
      render: (estado) => <TagEstado estado={estado} />,
    },
    {
      title: "Accion",
      key: "accion",
      align: "center",
      render: (fila) =>
        fila.estado === "FINALIZADO" ? (
          <Tooltip title="Descargar archivo">
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              size="small"
              onClick={() => onClickDescargar(fila.id)}
            >
              Descargar
            </Button>
          </Tooltip>
        ) : null,
    },
  ];

  const BotonesExtra = () => (
    <Tooltip title="Actualizar estado de los reportes">
      <Button icon={<ReloadOutlined />} loading={loadingRefrescar} onClick={cargarDatos}>
        Refrescar
      </Button>
    </Tooltip>
  );

  return (
    <Container
      icono={<UnorderedListOutlined />}
      titulo="Bandeja de Reportes - Consulta Documento"
      botonExtra={<BotonesExtra />}
    >
      <Table
        rowKey={(reporte) => reporte.id}
        columns={columnas}
        dataSource={reportes}
        loading={loadingRefrescar}
      />
    </Container>
  );
};

const TagEstado = ({ estado }) => {
  switch (estado) {
    case "PENDIENTE":
      return (
        <Tag icon={<ClockCircleOutlined />} color="default">
          Pendiente
        </Tag>
      );
    case "PROCESANDO":
      return (
        <Tag icon={<SyncOutlined spin />} color="processing">
          Procesando...
        </Tag>
      );
    case "FINALIZADO":
      return (
        <Tag icon={<CheckCircleOutlined />} color="success">
          Listo para descargar
        </Tag>
      );
    case "ERROR":
      return (
        <Tag icon={<CloseCircleOutlined />} color="error">
          Error
        </Tag>
      );
    default:
      return <Tag color="default">{estado}</Tag>;
  }
};

export default BandejaReportesConsultaDocumentoPage;
